import Cookies from "js-cookie";

export function getAuthorizationHeader() {
  return {
    headers: {
      "Authorization": `Bearer ${Cookies.get("kingdynasty_ec_token") || ''}`
    }
  };
}